import React, {
  useEffect,
  useState,
  useCallback,
  useRef
} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './fader.css'
import NavDots from './nav-dots'

function Fader({
  children,
  interval,
  rentalInfo,
  handleChange
}) {
  const [showItem, setShowItem] = useState(0)
  const timerRef = useRef(null)

  useEffect(() => {
    handleChange(showItem)
  }, [showItem])

  const switchFade = useCallback((item) => {
    setShowItem((prev) => {
      if (typeof item !== 'undefined') {
        return item
      }

      if (children.length <= prev + 1) {
        return 0
      }

      return prev + 1
    })
  }, [children.length])

  const clickToSwitch = useCallback((item) => {
    switchFade(item)

    if (timerRef.current) clearInterval(timerRef.current)

    timerRef.current = setInterval(() => {
      switchFade()
    }, interval)
  }, [interval, switchFade])

  // start interval on mount
  useEffect(() => {
    timerRef.current = setInterval(() => {
      switchFade()
    }, interval)

    return () => {
      if (timerRef.current) clearInterval(timerRef.current)
    }
  }, [interval, switchFade])

  const updatedChildren = React.Children.map(children, (child, index) => {
    return React.cloneElement(child, {
      index,
      showItem,
      className: classnames(styles.slide, {
        [styles.show]: index === showItem
      })
    })
  })

  return (
    <div
      className={styles.container}
    >
      {updatedChildren}
      {children.length > 1 && (
        <NavDots
          onClick={clickToSwitch}
          count={children.length}
          current={showItem}
          rentalInfo={rentalInfo}
        />
      )}
    </div>
  )
}

Fader.propTypes = {
  interval: PropTypes.number,
  rentalInfo: PropTypes.arrayOf(PropTypes.bool).isRequired,
  handleChange: PropTypes.func
}

Fader.defaultProps = {
  interval: 5000,
  handleChange: null
}

export default Fader
